/* Vexillum — ALD-blueprint Phase 1: builds the two PDP rails (C1).
   ≥990px: wraps the product-details blocks into .vex-rail--left (title/blurb/divider/
   accordions/complete-set) and .vex-rail--right (variant picker/buy/badge), then tags the
   grid with .vex-pdp-3col. Below 990px (or on teardown) the original DOM order is restored.
   Re-render resilient: MutationObserver rebuilds after Horizon morphs the section.

   IMPORTANT (fix 2026-08-17): this script is loaded synchronously at the end of <body>, so the
   first build() runs BEFORE Horizon's module scripts upgrade the custom elements. Moving an
   already-upgraded Horizon component (product-form-component, product-price, variant-picker…)
   disconnects it and its listeners never come back (its AbortController is aborted on
   disconnect) — the buy form then adds the page's initial variant to the cart. If a move ever
   has to happen after upgrade (window resized across 990px), moved blocks are replaced by fresh
   clones so every component connects once, cleanly. */
(function () {
  'use strict';
  var MQ = window.matchMedia('(min-width: 990px)');
  var RIGHT_SEL = 'variant-picker, .buy-buttons-block, [class*="buy-buttons"], .image-block';
  var UPGRADEABLE = 'product-form-component, product-price, variant-picker, quantity-selector-component, add-to-cart-component, accordion-custom';

  function getContent() {
    var grid = document.querySelector('.product-information__grid');
    if (!grid) return null;
    var content = grid.querySelector('.product-details .group-block-content');
    return content ? { grid: grid, content: content } : null;
  }

  function upgraded() {
    try { return !!(window.customElements && customElements.get('product-form-component')); } catch (e) { return false; }
  }

  /* Move k into parent. If Horizon components are already upgraded and k contains any, use a
     fresh clone so the component instances re-initialise instead of coming back dead. */
  function place(parent, k) {
    var needsClone = upgraded() && (k.matches(UPGRADEABLE) || k.querySelector(UPGRADEABLE));
    if (!needsClone) { parent.appendChild(k); return; }
    var c = k.cloneNode(true);
    /* let vexillum-pdp.js rebuild its size dropdown on the fresh clone */
    Array.prototype.slice.call(c.querySelectorAll('.vex-size-select')).forEach(function (s) { s.remove(); });
    Array.prototype.slice.call(c.querySelectorAll('[data-vex-dropped]')).forEach(function (f) { f.removeAttribute('data-vex-dropped'); f.classList.remove('vex-size-dropped'); });
    parent.appendChild(c);
    k.remove();
  }

  function build() {
    var ctx = getContent();
    if (!ctx || !MQ.matches) return;
    if (ctx.content.querySelector(':scope > .vex-rail--left')) { ctx.grid.classList.add('vex-pdp-3col'); return; }
    var kids = Array.prototype.slice.call(ctx.content.children).filter(function (k) {
      return !k.classList.contains('vex-rail');
    });
    if (!kids.length) return;
    var left = document.createElement('div');
    left.className = 'vex-rail vex-rail--left';
    var right = document.createElement('div');
    right.className = 'vex-rail vex-rail--right';
    kids.forEach(function (k, i) {
      k.setAttribute('data-vex-order', String(i));
      if (k.matches(RIGHT_SEL)) place(right, k);
      else place(left, k);
    });
    ctx.content.appendChild(left);
    ctx.content.appendChild(right);
    ctx.grid.classList.add('vex-pdp-3col');
  }

  function teardown() {
    var ctx = getContent();
    if (!ctx) return;
    var rails = ctx.content.querySelectorAll(':scope > .vex-rail');
    if (!rails.length) return;
    var restored = [];
    rails.forEach(function (r) {
      Array.prototype.slice.call(r.children).forEach(function (k) { restored.push(k); });
    });
    restored.sort(function (a, b) {
      return (+a.getAttribute('data-vex-order') || 0) - (+b.getAttribute('data-vex-order') || 0);
    });
    restored.forEach(function (k) { place(ctx.content, k); });
    rails.forEach(function (r) { r.remove(); });
    ctx.grid.classList.remove('vex-pdp-3col');
  }

  function sync() { if (MQ.matches) build(); else teardown(); }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; sync(); });
  }

  function observe() {
    var section = document.querySelector('.product-information') || document.body;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.closest && t.closest('.vex-rail')) continue; // our own moves
        schedule();
        return;
      }
    }).observe(section, { childList: true, subtree: true });
  }

  /* First pass right now (script sits at the end of <body>, the product DOM is already parsed
     and Horizon's modules have not run yet). */
  try { sync(); } catch (e) {}
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); observe(); });
  } else { observe(); }
  if (MQ.addEventListener) MQ.addEventListener('change', sync);
  else if (MQ.addListener) MQ.addListener(sync);
})();
